import styled from 'styled-components';
import { SwitchSize } from 'styled-system';

export const Container = styled.div<{ size: SwitchSize }>`
  position: relative;
  padding: ${({ size, theme }) =>
    size === 's' ? theme.spacing.S2 : theme.spacing.S4};
  width: ${({ size, theme }) =>
    size === 's' ? theme.spacing.M32 : theme.spacing.L56};
`;

export const Input = styled.input`
  position: absolute;
  z-index: 2; // Ensure input is above the track and disc for clicking
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 400px;
  opacity: 0; // Hide the input visually but keep it accessible
  cursor: pointer;
`;

export const Disc = styled.div<{ size: SwitchSize }>`
  width: ${({ size, theme }) =>
    size === 's' ? theme.spacing.M16 : theme.spacing.M24};
  height: ${({ size, theme }) =>
    size === 's' ? theme.spacing.M16 : theme.spacing.M24};
  background: #ffffff;
  border-radius: 50%;
  transform: translateX(0);
  transition: transform 0.2s linear;

  input:checked ~ & {
    transform: translateX(
      ${({ size, theme }) =>
        size === 's' ? theme.spacing.S12 : theme.spacing.M24}
    );
  }
  input:disabled ~ & {
    background: ${({ theme }) => theme.brand.secondary.base};
  }
`;

export const Track = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.brand.secondary.light};
  border-radius: 400px;
  transition: background 0.2s linear;

  input:checked ~ & {
    background: ${({ theme }) => theme.brand.primary.base};
  }
  input:disabled ~ & {
    background: ${({ theme }) => theme.brand.secondary.light};
  }
  input:focus-visible ~ & {
    outline: 2px solid ${({ theme }) => theme.brand.primary.base};
    outline-offset: 2px;
  }
`;
